/**
 * TerminationLettersPanel (P6-S3, Stefan 19.1, OQ-S3-1) - the read-only Versandkontrolle section
 * «Bestätigungen Mandatsauflösung»: the Dankesbriefe still waiting (ausstehend: lost job or to print)
 * or failed. The state lives on the termination, not on a Vorgang; the actions are on the customer's
 * «Mandate & Eintragungen». Hidden without crm.read and while nothing is open.
 */

import { useQuery } from '@tanstack/react-query';
import { formatIsoDayDe } from '@brokly/shared';
import { useEffectivePermissions } from '../../administration/useEffectivePermissions';
import { apiClient } from '../../../lib/api-client';
import { qk } from '../../../lib/query-keys';
import { letterStateText } from './TerminationLetterRow';

const STATUSES = ['ausstehend', 'fehlgeschlagen'];

export function TerminationLettersPanel() {
  const { can } = useEffectivePermissions();
  const allowed = can('crm.read');
  const q = useQuery({
    queryKey: qk.terminationLetters(STATUSES.join(',')),
    queryFn: () => apiClient.mandateTermination.listByLetterStatus(STATUSES),
    enabled: allowed,
  });
  const rows = q.data ?? [];
  if (!allowed || rows.length === 0) return null;
  return (
    <section className="mb-6 rounded border p-3" aria-label="Bestätigungen Mandatsauflösung" data-testid="termination-letters-panel">
      <h3 className="mb-2 text-sm font-semibold">Bestätigungen Mandatsauflösung</h3>
      <ul className="flex flex-col gap-1 text-sm">
        {rows.map((t) => (
          <li key={t.id} className="flex flex-wrap gap-2">
            {/* review M1: the customer and the way to his «Mandate & Eintragungen», where the actions are */}
            <a className="underline" href={`/kunden/${encodeURIComponent(t.subjectId)}?tab=mandate_eintragungen`}>
              {t.subjectName || 'Kunde'}
            </a>
            <span className="font-mono text-xs">{t.processNumber}</span>
            {t.endDate && <span className="text-muted-foreground">per {formatIsoDayDe(t.endDate)}</span>}
            <span className={t.letter?.status === 'fehlgeschlagen' ? 'text-destructive' : ''}>{letterStateText(t.letter)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
